// Copyright 2026. WebPros International GmbH. All rights reserved.

import moment from 'moment';

/**
 * Computes a human-readable duration string from two ISO timestamps.
 * Returns null if either timestamp is missing.
 *
 * Examples: "< 1 min", "5 min", "1 h 30 min"
 */
export const formatDuration = (startedAt: string | null, endedAt: string | null): string | null => {
    if (!startedAt || !endedAt) {
        return null;
    }

    const start = moment(startedAt);
    const end = moment(endedAt);

    if (!start.isValid() || !end.isValid()) {
        return null;
    }

    const diffMs = end.diff(start);
    if (diffMs < 0) {
        return null;
    }

    const duration = moment.duration(diffMs);
    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();

    if (hours === 0 && minutes === 0) {
        return '< 1 min';
    }

    if (hours === 0) {
        return `${minutes} min`;
    }

    if (minutes === 0) {
        return `${hours} h`;
    }

    return `${hours} h ${minutes} min`;
};
